import {
	type FetchPledgeCampaignLeaderboardByCampaignData,
	type FetchPledgeCampaignLeaderboardByCampaignParams,
	minutesToMs,
	pledgeApi
} from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';

export const usePledgeCampaignLeaderboardQuery = (params: FetchPledgeCampaignLeaderboardByCampaignParams) => {
	return useQuery({
		enabled: !!params.campaign,
		queryFn: async () => {
			return (await pledgeApi).fetchPledgeCampaignLeaderboardByCampaign(
				params
			) as Promise<FetchPledgeCampaignLeaderboardByCampaignData>;
		},
		queryKey: ['pledge-campaign-leaderboard', params],
		select: res => res.data,
		staleTime: minutesToMs(5)
	});
};
